<!-- Button für die Device Auswahl beim Alarm setzen -->
<!--Copy right - © 2024 tecera gmbh-->

<script>
    import { selected_device } from "../../stores.js";
    import { onMount } from "svelte";

    export let device_list;
    export let is_disabled=false;
    let isOpen = false;
  

    onMount(() => {
        const handleClickOutside = (event) => {
            if (isOpen && !event.target.closest(".dropdown-toggle")) {
                isOpen = false;
            }
        };

        document.addEventListener("click", handleClickOutside);

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    });

</script>

<div class="input-group mb-1">
    <button
        class="btn btn-primary btn-normal btn-block dropdown-toggle"
        id="sensor_grenzwerte_btn"
        type="button"
        data-display="static"
        aria-haspopup="true"
        on:click={() => (isOpen = !isOpen)}
        >{$selected_device && !is_disabled ?  $selected_device.name:"Gerät wählen"}  </button
    >

    <div
        class="dropdown-menu filter_dropdown mt-2 {isOpen ? 'show' : ''}"
        aria-labelledby="sensor_grenzwerte_btn"
    >
        <div
            class="filter_dropdown_scrollable pl-2 pr-2"
            id="sensoren_grenzwerte"
        >
            {#if $device_list}
                {#each $device_list as device_config (device_config.id)}
                    <button
                        class="btn btn-primary btn-block btn-normal"
                        on:click={() => {
                            $selected_device = device_config;
                        }}>{device_config.name}</button
                    >
                {/each}
            {/if}
        </div>
    </div>
</div>
